import { UserSelect } from './User';
export var ChangeLogWithUser = {
    user: {
        select: UserSelect,
    },
};
export var ChangeLogSelect = {
    id: true,
    createdAt: true,
    deletedAt: true,
    deleted: true,
    logId: true,
    userId: true,
    logEntryId: true,
    organizationId: true,
    action: true,
    property: true,
    type: true,
    previousValue: true,
    value: true,
    timestamp: true,
};
//# sourceMappingURL=Changelog.js.map